export default {
  methods: {
    //處理變成scenes被後臺處理成數組的數據
    handleErrorSceneTypesByMixin() {
      if(Array.isArray(this.cloneSandtable.scenes) && this.cloneSandtable.scenes.length === 0) {
        this.cloneSandtable.scenes = {};
      }
    },
  }
}